import { components } from "types/openapi";
import { TCommonStatus } from "./statuses";
import { CompanyRole } from "./companies";

export type UserScope =
  | "SENIOR_CUSTOMER"
  | "JUNIOR_CUSTOMER"
  | "SENIOR_LP"
  | "JUNIOR_LP"
  | "SENIOR_OPERATOR"
  | "JUNIOR_OPERATOR"
  | "RISK_MANAGER"
  | "SYSTEM_ADMIN"
  | "USER_ADMIN"
  | "COMPANY_DOC_UPLOADING"
  | "PASSWORD_CHANGE"
  | "LP_RISK_MANAGER";
export type CompanyUserDto = components["schemas"]["CompanyUserDto"];
export type UserStatus = components["schemas"]["UserDto"]["status"];
export type UserListEntity = components["schemas"]["UserDto"];
export type UserCreateRequest = components["schemas"]["CreateUserRequest"];

export interface IUserInfo {
  sub: string;
  surname: string;
  phone: string;
  iss: string;
  email: string;
  name: string;
  second_name: string;
  company_role: CompanyRole;
  aud: string;
  status: UserStatus;
  nbf: number;
  scope: UserScope[];
  id: string;
  exp: number;
  iat: number;
  jti: string;
  company_id: string;
  company_reg_num: string;
  company_name: string;
}

export const USER_ROLES: TCommonStatus<UserScope> = {
  texts: {
    SENIOR_CUSTOMER: "Старший УВЭД",
    JUNIOR_CUSTOMER: "Младший УВЭД",
    SENIOR_LP: "Старший ПЛ",
    LP_RISK_MANAGER: "Риск-менеджер ПЛ",
    JUNIOR_LP: "Младший ПЛ",
    SENIOR_OPERATOR: "Старший операционист",
    JUNIOR_OPERATOR: "Младший операционист",
    RISK_MANAGER: "Риск-менеджер",
    SYSTEM_ADMIN: "Администратор системный",
    USER_ADMIN: "Администратор пользователей",
    COMPANY_DOC_UPLOADING: "",
    PASSWORD_CHANGE: "",
  },
  colors: {
    SENIOR_CUSTOMER: "blue",
    JUNIOR_CUSTOMER: "blue",
    SENIOR_LP: "blue",
    JUNIOR_LP: "blue",
    LP_RISK_MANAGER: "blue",
    SENIOR_OPERATOR: "blue",
    JUNIOR_OPERATOR: "blue",
    RISK_MANAGER: "blue",
    SYSTEM_ADMIN: "blue",
    USER_ADMIN: "blue",
    COMPANY_DOC_UPLOADING: "",
    PASSWORD_CHANGE: "",
  },
};

export const USER_SCOPE_TEXTS: TCommonStatus<UserStatus> = {
  texts: {
    ACTIVE: "Активный",
    DRAFT: "Черновик",
    BLOCKED: "Заблокирован",
  },
  colors: {
    ACTIVE: "green",
    BLOCKED: "red",
    DRAFT: "gray",
  },
};

export const USER_SCOPE_ENUM = {
  SENIOR_CUSTOMER: "SENIOR_CUSTOMER",
  JUNIOR_CUSTOMER: "JUNIOR_CUSTOMER",
  SENIOR_LP: "SENIOR_LP",
  JUNIOR_LP: "JUNIOR_LP",
  LP_RISK_MANAGER: "LP_RISK_MANAGER",
  SENIOR_OPERATOR: "SENIOR_OPERATOR",
  JUNIOR_OPERATOR: "JUNIOR_OPERATOR",
  RISK_MANAGER: "RISK_MANAGER",
  SYSTEM_ADMIN: "SYSTEM_ADMIN",
  USER_ADMIN: "USER_ADMIN",
  COMPANY_DOC_UPLOADING: "COMPANY_DOC_UPLOADING",
  PASSWORD_CHANGE: "PASSWORD_CHANGE",
} as const;
type CheckScopeKeysMatch = UserScope extends keyof typeof USER_SCOPE_ENUM ? true : false;
export const checkScopeKeysMatch: CheckScopeKeysMatch = true;

export const USER_STATUS_ENUM = {
  DRAFT: "DRAFT",
  ACTIVE: "ACTIVE",
  BLOCKED: "BLOCKED",
} as const;
type CheckStatusKeysMatch = UserStatus extends keyof typeof USER_STATUS_ENUM ? true : false;
export const checkUserStatusKeys: CheckStatusKeysMatch = true;

export const isUserActive = (status: string): boolean => {
  return status !== USER_STATUS_ENUM.BLOCKED;
};

export const TOKEN_ERROR_TYPE_ENUM = {
  INVALID_TOKEN: "invalid_token",
};
